import { color } from '@mui/system'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import TabsInspeccionar from './TabsInspeccionarComponent'
import estilos from './TabsInspeccionarComponent.module.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { useContext, createContext } from 'react';
import InspectorEnCampoContext from '../../Context/InspectorEnCampoContext';
import TabsSeguimientoComponent from './TabsSeguimientoComponent'


function TabsPanelInspeccion(props) {


    const [tabUno, setTabUno] = React.useState(true)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)
    const [tabCuatro, setTabCuatro] = React.useState(false)

    const { dictaminarContext, setDictaminarContext } = useContext(InspectorEnCampoContext);

    const todo = props.detalles;
    const instalacion = props.instalacion;
    const idinforme = props.idinforme;
    const dataUser = props.inspectorLogeado;
    const verdaderaInstalacion = props.verdaderaInstalacion;
    const optionTab = props.optionTab;
    const ncomision = props.ncomision;
    const folioui = props.folioui;
    const solicitud = props.solicitud;

    //PRODUCCION
    const setearValoresUno = () => {
        setTabUno(true); setTabDos(false); setTabTres(false); setTabCuatro(false);
    }
    const setearValoresDos = () => {
        setTabUno(false); setTabDos(true); setTabTres(false); setTabCuatro(false);
    }
    const setearValoresTres = () => {
        setTabUno(false); setTabDos(false); setTabTres(true); setTabCuatro(false);
    }

    const volverTabla = () => {
        props.history.push("/PanelAsociados");
    }

    React.useEffect(() => {
        switch (optionTab) {
            case 1:
                setearValoresUno()
                break;
            case 2:
                setearValoresDos()
                break;
            case 3:
                setearValoresTres()
                break;
            default:
                break;
        }

    }, [todo])

    return (
        <Fragment>
            <div className={`row text-center mt-2 ${estilos.tabs}`}>
                {/**OPCIONES NIVEL 1 */}
                <div className='col-4'>
                    <button onClick={() => optionTab == 1 ? setearValoresUno() : null} type="button" className={`btn ${estilos.block}`} style={{ background: optionTab == 1 ? '#68813B' : 'gray', color: tabUno ? 'white' : 'white' }}>Dictaminar</button>
                </div>
                <div className='col-4'>
                    <button onClick={() => optionTab == 2 ? setearValoresDos() : null} className={`btn ${estilos.block}`} type="button" style={{ background: optionTab == 2 ? '#68813B' : 'grey', color: tabDos ? 'white' : 'white' }}>Producción (Seguimiento)</button>
                </div>
                <div className='col-4'>
                    <button onClick={() => optionTab == 3 ? setearValoresTres() : null} className={`btn ${estilos.block}`} type="button" style={{ background: optionTab == 3 ? '#68813B' : 'grey', color: tabTres ? 'white' : 'white' }}>Granel (Inventario)</button>

                </div>

                {/* TIPO DE UNIDAD 
                    1.- Unidad de Producción
                    2.- Unidad de Envasado
                    3.- Unidad de Almacén            
                */}

                {
                    //Unidad de Produccion

                    tabUno ? (
                        <div className={`row text-center ${estilos.tabItem}`}>
                            <TabsInspeccionar detalles={todo} instalacion={instalacion} inspectorLogeado={dataUser} idinforme={idinforme} verdaderaInstalacion={verdaderaInstalacion} ncomision={ncomision} folioui={folioui} solicitud={solicitud}></TabsInspeccionar>
                            <div className="col-6">
                                <button type="button" className={`btn ${estilos.botonVerdeCOMERCAM}`} onClick={() => volverTabla()}><ArrowBackIcon /> Ir al Inicio</button>
                            </div>
                            <div className="col">
                                {/*   <button type="button" disabled className={`btn ${estilos.botonVerdeCOMERCAM}`} onClick={() => setearValoresDos()}><ArrowForwardIcon /> Producción</button>
                            */}
                            </div>
                        </div>

                    ) :
                        tabDos ? (
                            <div className={`row text-center ${estilos.tabItem}`}>
                                <div className="col ">
                                    <TabsSeguimientoComponent></TabsSeguimientoComponent>
                                </div>

                            </div>

                        ) :
                            tabTres ? (
                                <div className={`row text-center ${estilos.tabItem}`}>
                                    <div className={`row text-center ${estilos.tabItem}`}>
                                        <div className="col ">
                                            {/*  <button type="button" className={`btn ${estilos.botonVerdeCOMERCAM}`} onClick={() => setearValoresDos()}><ArrowBackIcon /> Producción</button>*/}
                                        </div>
                                    </div>
                                </div>
                            ) : <div></div>
                }

            </div>
        </Fragment>
    );
};

export default withRouter(TabsPanelInspeccion)